import { Media, PluginContainerData } from "./common.js";
import {
  AppEmbedData_AppType,
  AppEmbedData_ImageStyles_Position,
  AppEmbedData_ImageStyles_AspectRatio,
  AppEmbedData_ImageStyles_Resizing,
  AppEmbedData_RibbonStyles_Placement,
  AppEmbedData_CardStyles_Type,
  AppEmbedData_CardStyles_Alignment,
  AppEmbedData_CardStyles_Layout
} from "./plugin_app_embed.enums.js";
function appEmbedData_AppTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "PRODUCT":
      return AppEmbedData_AppType.PRODUCT;
    case 1:
    case "EVENT":
      return AppEmbedData_AppType.EVENT;
    case 2:
    case "BOOKING":
      return AppEmbedData_AppType.BOOKING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AppEmbedData_AppType.UNRECOGNIZED;
  }
}
function appEmbedData_AppTypeToJSON(object) {
  switch (object) {
    case AppEmbedData_AppType.PRODUCT:
      return "PRODUCT";
    case AppEmbedData_AppType.EVENT:
      return "EVENT";
    case AppEmbedData_AppType.BOOKING:
      return "BOOKING";
    default:
      return "UNKNOWN";
  }
}
function appEmbedData_ImageStyles_PositionFromJSON(object) {
  switch (object) {
    case 0:
    case "START":
      return AppEmbedData_ImageStyles_Position.START;
    case 1:
    case "END":
      return AppEmbedData_ImageStyles_Position.END;
    case 2:
    case "TOP":
      return AppEmbedData_ImageStyles_Position.TOP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AppEmbedData_ImageStyles_Position.UNRECOGNIZED;
  }
}
function appEmbedData_ImageStyles_PositionToJSON(object) {
  switch (object) {
    case AppEmbedData_ImageStyles_Position.START:
      return "START";
    case AppEmbedData_ImageStyles_Position.END:
      return "END";
    case AppEmbedData_ImageStyles_Position.TOP:
      return "TOP";
    default:
      return "UNKNOWN";
  }
}
function appEmbedData_ImageStyles_AspectRatioFromJSON(object) {
  switch (object) {
    case 0:
    case "SQUARE":
      return AppEmbedData_ImageStyles_AspectRatio.SQUARE;
    case 1:
    case "RECTANGLE":
      return AppEmbedData_ImageStyles_AspectRatio.RECTANGLE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AppEmbedData_ImageStyles_AspectRatio.UNRECOGNIZED;
  }
}
function appEmbedData_ImageStyles_AspectRatioToJSON(object) {
  switch (object) {
    case AppEmbedData_ImageStyles_AspectRatio.SQUARE:
      return "SQUARE";
    case AppEmbedData_ImageStyles_AspectRatio.RECTANGLE:
      return "RECTANGLE";
    default:
      return "UNKNOWN";
  }
}
function appEmbedData_ImageStyles_ResizingFromJSON(object) {
  switch (object) {
    case 0:
    case "FILL":
      return AppEmbedData_ImageStyles_Resizing.FILL;
    case 1:
    case "FIT":
      return AppEmbedData_ImageStyles_Resizing.FIT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AppEmbedData_ImageStyles_Resizing.UNRECOGNIZED;
  }
}
function appEmbedData_ImageStyles_ResizingToJSON(object) {
  switch (object) {
    case AppEmbedData_ImageStyles_Resizing.FILL:
      return "FILL";
    case AppEmbedData_ImageStyles_Resizing.FIT:
      return "FIT";
    default:
      return "UNKNOWN";
  }
}
function appEmbedData_RibbonStyles_PlacementFromJSON(object) {
  switch (object) {
    case 0:
    case "IMAGE":
      return AppEmbedData_RibbonStyles_Placement.IMAGE;
    case 1:
    case "PRODUCT_INFO":
      return AppEmbedData_RibbonStyles_Placement.PRODUCT_INFO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AppEmbedData_RibbonStyles_Placement.UNRECOGNIZED;
  }
}
function appEmbedData_RibbonStyles_PlacementToJSON(object) {
  switch (object) {
    case AppEmbedData_RibbonStyles_Placement.IMAGE:
      return "IMAGE";
    case AppEmbedData_RibbonStyles_Placement.PRODUCT_INFO:
      return "PRODUCT_INFO";
    default:
      return "UNKNOWN";
  }
}
function appEmbedData_CardStyles_TypeFromJSON(object) {
  switch (object) {
    case 0:
    case "CONTAINED":
      return AppEmbedData_CardStyles_Type.CONTAINED;
    case 1:
    case "FRAMELESS":
      return AppEmbedData_CardStyles_Type.FRAMELESS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AppEmbedData_CardStyles_Type.UNRECOGNIZED;
  }
}
function appEmbedData_CardStyles_TypeToJSON(object) {
  switch (object) {
    case AppEmbedData_CardStyles_Type.CONTAINED:
      return "CONTAINED";
    case AppEmbedData_CardStyles_Type.FRAMELESS:
      return "FRAMELESS";
    default:
      return "UNKNOWN";
  }
}
function appEmbedData_CardStyles_AlignmentFromJSON(object) {
  switch (object) {
    case 0:
    case "START":
      return AppEmbedData_CardStyles_Alignment.START;
    case 1:
    case "CENTER":
      return AppEmbedData_CardStyles_Alignment.CENTER;
    case 2:
    case "END":
      return AppEmbedData_CardStyles_Alignment.END;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AppEmbedData_CardStyles_Alignment.UNRECOGNIZED;
  }
}
function appEmbedData_CardStyles_AlignmentToJSON(object) {
  switch (object) {
    case AppEmbedData_CardStyles_Alignment.START:
      return "START";
    case AppEmbedData_CardStyles_Alignment.CENTER:
      return "CENTER";
    case AppEmbedData_CardStyles_Alignment.END:
      return "END";
    default:
      return "UNKNOWN";
  }
}
function appEmbedData_CardStyles_LayoutFromJSON(object) {
  switch (object) {
    case 0:
    case "STACKED":
      return AppEmbedData_CardStyles_Layout.STACKED;
    case 1:
    case "SIDE_BY_SIDE":
      return AppEmbedData_CardStyles_Layout.SIDE_BY_SIDE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AppEmbedData_CardStyles_Layout.UNRECOGNIZED;
  }
}
function appEmbedData_CardStyles_LayoutToJSON(object) {
  switch (object) {
    case AppEmbedData_CardStyles_Layout.STACKED:
      return "STACKED";
    case AppEmbedData_CardStyles_Layout.SIDE_BY_SIDE:
      return "SIDE_BY_SIDE";
    default:
      return "UNKNOWN";
  }
}
const baseAppEmbedData = { type: AppEmbedData_AppType.PRODUCT };
const AppEmbedData = {
  fromJSON(object) {
    const message = { ...baseAppEmbedData };
    message.type = object.type !== void 0 && object.type !== null ? appEmbedData_AppTypeFromJSON(object.type) : AppEmbedData_AppType.PRODUCT;
    message.itemId = object.itemId !== void 0 && object.itemId !== null ? String(object.itemId) : void 0;
    message.name = object.name !== void 0 && object.name !== null ? String(object.name) : void 0;
    message.imageSrc = object.imageSrc !== void 0 && object.imageSrc !== null ? String(object.imageSrc) : void 0;
    message.url = object.url !== void 0 && object.url !== null ? String(object.url) : void 0;
    message.image = object.image !== void 0 && object.image !== null ? Media.fromJSON(object.image) : void 0;
    message.bookingData = object.bookingData !== void 0 && object.bookingData !== null ? AppEmbedData_BookingData.fromJSON(object.bookingData) : void 0;
    message.eventData = object.eventData !== void 0 && object.eventData !== null ? AppEmbedData_EventData.fromJSON(object.eventData) : void 0;
    message.hideImage = object.hideImage !== void 0 && object.hideImage !== null ? Boolean(object.hideImage) : void 0;
    message.hideTitle = object.hideTitle !== void 0 && object.hideTitle !== null ? Boolean(object.hideTitle) : void 0;
    message.hidePrice = object.hidePrice !== void 0 && object.hidePrice !== null ? Boolean(object.hidePrice) : void 0;
    message.hideDescription = object.hideDescription !== void 0 && object.hideDescription !== null ? Boolean(object.hideDescription) : void 0;
    message.hideDateTime = object.hideDateTime !== void 0 && object.hideDateTime !== null ? Boolean(object.hideDateTime) : void 0;
    message.hideLocation = object.hideLocation !== void 0 && object.hideLocation !== null ? Boolean(object.hideLocation) : void 0;
    message.hideDuration = object.hideDuration !== void 0 && object.hideDuration !== null ? Boolean(object.hideDuration) : void 0;
    message.hideButton = object.hideButton !== void 0 && object.hideButton !== null ? Boolean(object.hideButton) : void 0;
    message.hideRibbon = object.hideRibbon !== void 0 && object.hideRibbon !== null ? Boolean(object.hideRibbon) : void 0;
    message.buttonStyles = object.buttonStyles !== void 0 && object.buttonStyles !== null ? AppEmbedData_ButtonStyles.fromJSON(object.buttonStyles) : void 0;
    message.imageStyles = object.imageStyles !== void 0 && object.imageStyles !== null ? AppEmbedData_ImageStyles.fromJSON(object.imageStyles) : void 0;
    message.ribbonStyles = object.ribbonStyles !== void 0 && object.ribbonStyles !== null ? AppEmbedData_RibbonStyles.fromJSON(object.ribbonStyles) : void 0;
    message.cardStyles = object.cardStyles !== void 0 && object.cardStyles !== null ? AppEmbedData_CardStyles.fromJSON(object.cardStyles) : void 0;
    message.containerData = object.containerData !== void 0 && object.containerData !== null ? PluginContainerData.fromJSON(object.containerData) : void 0;
    message.pricingData = object.pricingData !== void 0 && object.pricingData !== null ? AppEmbedData_PricingData.fromJSON(object.pricingData) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.type !== void 0 && (obj.type = appEmbedData_AppTypeToJSON(message.type));
    message.itemId !== void 0 && (obj.itemId = message.itemId);
    message.name !== void 0 && (obj.name = message.name);
    message.imageSrc !== void 0 && (obj.imageSrc = message.imageSrc);
    message.url !== void 0 && (obj.url = message.url);
    message.image !== void 0 && (obj.image = message.image ? Media.toJSON(message.image) : void 0);
    message.bookingData !== void 0 && (obj.bookingData = message.bookingData ? AppEmbedData_BookingData.toJSON(message.bookingData) : void 0);
    message.eventData !== void 0 && (obj.eventData = message.eventData ? AppEmbedData_EventData.toJSON(message.eventData) : void 0);
    message.hideImage !== void 0 && (obj.hideImage = message.hideImage);
    message.hideTitle !== void 0 && (obj.hideTitle = message.hideTitle);
    message.hidePrice !== void 0 && (obj.hidePrice = message.hidePrice);
    message.hideDescription !== void 0 && (obj.hideDescription = message.hideDescription);
    message.hideDateTime !== void 0 && (obj.hideDateTime = message.hideDateTime);
    message.hideLocation !== void 0 && (obj.hideLocation = message.hideLocation);
    message.hideDuration !== void 0 && (obj.hideDuration = message.hideDuration);
    message.hideButton !== void 0 && (obj.hideButton = message.hideButton);
    message.hideRibbon !== void 0 && (obj.hideRibbon = message.hideRibbon);
    message.buttonStyles !== void 0 && (obj.buttonStyles = message.buttonStyles ? AppEmbedData_ButtonStyles.toJSON(message.buttonStyles) : void 0);
    message.imageStyles !== void 0 && (obj.imageStyles = message.imageStyles ? AppEmbedData_ImageStyles.toJSON(message.imageStyles) : void 0);
    message.ribbonStyles !== void 0 && (obj.ribbonStyles = message.ribbonStyles ? AppEmbedData_RibbonStyles.toJSON(message.ribbonStyles) : void 0);
    message.cardStyles !== void 0 && (obj.cardStyles = message.cardStyles ? AppEmbedData_CardStyles.toJSON(message.cardStyles) : void 0);
    message.containerData !== void 0 && (obj.containerData = message.containerData ? PluginContainerData.toJSON(message.containerData) : void 0);
    message.pricingData !== void 0 && (obj.pricingData = message.pricingData ? AppEmbedData_PricingData.toJSON(message.pricingData) : void 0);
    return obj;
  }
};
const baseAppEmbedData_ButtonStyles = {};
const AppEmbedData_ButtonStyles = {
  fromJSON(object) {
    const message = { ...baseAppEmbedData_ButtonStyles };
    message.buttonText = object.buttonText !== void 0 && object.buttonText !== null ? String(object.buttonText) : void 0;
    message.borderWidth = object.borderWidth !== void 0 && object.borderWidth !== null ? Number(object.borderWidth) : void 0;
    message.borderRadius = object.borderRadius !== void 0 && object.borderRadius !== null ? Number(object.borderRadius) : void 0;
    message.borderColor = object.borderColor !== void 0 && object.borderColor !== null ? String(object.borderColor) : void 0;
    message.textColor = object.textColor !== void 0 && object.textColor !== null ? String(object.textColor) : void 0;
    message.backgroundColor = object.backgroundColor !== void 0 && object.backgroundColor !== null ? String(object.backgroundColor) : void 0;
    message.borderColorHover = object.borderColorHover !== void 0 && object.borderColorHover !== null ? String(object.borderColorHover) : void 0;
    message.textColorHover = object.textColorHover !== void 0 && object.textColorHover !== null ? String(object.textColorHover) : void 0;
    message.backgroundColorHover = object.backgroundColorHover !== void 0 && object.backgroundColorHover !== null ? String(object.backgroundColorHover) : void 0;
    message.buttonSize = object.buttonSize !== void 0 && object.buttonSize !== null ? String(object.buttonSize) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.buttonText !== void 0 && (obj.buttonText = message.buttonText);
    message.borderWidth !== void 0 && (obj.borderWidth = message.borderWidth);
    message.borderRadius !== void 0 && (obj.borderRadius = message.borderRadius);
    message.borderColor !== void 0 && (obj.borderColor = message.borderColor);
    message.textColor !== void 0 && (obj.textColor = message.textColor);
    message.backgroundColor !== void 0 && (obj.backgroundColor = message.backgroundColor);
    message.borderColorHover !== void 0 && (obj.borderColorHover = message.borderColorHover);
    message.textColorHover !== void 0 && (obj.textColorHover = message.textColorHover);
    message.backgroundColorHover !== void 0 && (obj.backgroundColorHover = message.backgroundColorHover);
    message.buttonSize !== void 0 && (obj.buttonSize = message.buttonSize);
    return obj;
  }
};
const baseAppEmbedData_ImageStyles = {
  imagePosition: AppEmbedData_ImageStyles_Position.START,
  aspectRatio: AppEmbedData_ImageStyles_AspectRatio.SQUARE,
  resizing: AppEmbedData_ImageStyles_Resizing.FILL
};
const AppEmbedData_ImageStyles = {
  fromJSON(object) {
    const message = { ...baseAppEmbedData_ImageStyles };
    message.hideImage = object.hideImage !== void 0 && object.hideImage !== null ? Boolean(object.hideImage) : void 0;
    message.imagePosition = object.imagePosition !== void 0 && object.imagePosition !== null ? appEmbedData_ImageStyles_PositionFromJSON(object.imagePosition) : AppEmbedData_ImageStyles_Position.START;
    message.aspectRatio = object.aspectRatio !== void 0 && object.aspectRatio !== null ? appEmbedData_ImageStyles_AspectRatioFromJSON(object.aspectRatio) : AppEmbedData_ImageStyles_AspectRatio.SQUARE;
    message.resizing = object.resizing !== void 0 && object.resizing !== null ? appEmbedData_ImageStyles_ResizingFromJSON(object.resizing) : AppEmbedData_ImageStyles_Resizing.FILL;
    message.borderColor = object.borderColor !== void 0 && object.borderColor !== null ? String(object.borderColor) : void 0;
    message.borderWidth = object.borderWidth !== void 0 && object.borderWidth !== null ? Number(object.borderWidth) : void 0;
    message.borderRadius = object.borderRadius !== void 0 && object.borderRadius !== null ? Number(object.borderRadius) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.hideImage !== void 0 && (obj.hideImage = message.hideImage);
    message.imagePosition !== void 0 && (obj.imagePosition = appEmbedData_ImageStyles_PositionToJSON(message.imagePosition));
    message.aspectRatio !== void 0 && (obj.aspectRatio = appEmbedData_ImageStyles_AspectRatioToJSON(message.aspectRatio));
    message.resizing !== void 0 && (obj.resizing = appEmbedData_ImageStyles_ResizingToJSON(message.resizing));
    message.borderColor !== void 0 && (obj.borderColor = message.borderColor);
    message.borderWidth !== void 0 && (obj.borderWidth = message.borderWidth);
    message.borderRadius !== void 0 && (obj.borderRadius = message.borderRadius);
    return obj;
  }
};
const baseAppEmbedData_RibbonStyles = {
  ribbonPlacement: AppEmbedData_RibbonStyles_Placement.IMAGE
};
const AppEmbedData_RibbonStyles = {
  fromJSON(object) {
    const message = { ...baseAppEmbedData_RibbonStyles };
    message.ribbonText = object.ribbonText !== void 0 && object.ribbonText !== null ? String(object.ribbonText) : void 0;
    message.backgroundColor = object.backgroundColor !== void 0 && object.backgroundColor !== null ? String(object.backgroundColor) : void 0;
    message.textColor = object.textColor !== void 0 && object.textColor !== null ? String(object.textColor) : void 0;
    message.borderColor = object.borderColor !== void 0 && object.borderColor !== null ? String(object.borderColor) : void 0;
    message.borderWidth = object.borderWidth !== void 0 && object.borderWidth !== null ? Number(object.borderWidth) : void 0;
    message.borderRadius = object.borderRadius !== void 0 && object.borderRadius !== null ? Number(object.borderRadius) : void 0;
    message.ribbonPlacement = object.ribbonPlacement !== void 0 && object.ribbonPlacement !== null ? appEmbedData_RibbonStyles_PlacementFromJSON(object.ribbonPlacement) : AppEmbedData_RibbonStyles_Placement.IMAGE;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.ribbonText !== void 0 && (obj.ribbonText = message.ribbonText);
    message.backgroundColor !== void 0 && (obj.backgroundColor = message.backgroundColor);
    message.textColor !== void 0 && (obj.textColor = message.textColor);
    message.borderColor !== void 0 && (obj.borderColor = message.borderColor);
    message.borderWidth !== void 0 && (obj.borderWidth = message.borderWidth);
    message.borderRadius !== void 0 && (obj.borderRadius = message.borderRadius);
    message.ribbonPlacement !== void 0 && (obj.ribbonPlacement = appEmbedData_RibbonStyles_PlacementToJSON(message.ribbonPlacement));
    return obj;
  }
};
const baseAppEmbedData_CardStyles = {
  type: AppEmbedData_CardStyles_Type.CONTAINED,
  alignment: AppEmbedData_CardStyles_Alignment.START,
  titlePriceLayout: AppEmbedData_CardStyles_Layout.STACKED
};
const AppEmbedData_CardStyles = {
  fromJSON(object) {
    const message = { ...baseAppEmbedData_CardStyles };
    message.backgroundColor = object.backgroundColor !== void 0 && object.backgroundColor !== null ? String(object.backgroundColor) : void 0;
    message.borderColor = object.borderColor !== void 0 && object.borderColor !== null ? String(object.borderColor) : void 0;
    message.borderWidth = object.borderWidth !== void 0 && object.borderWidth !== null ? Number(object.borderWidth) : void 0;
    message.borderRadius = object.borderRadius !== void 0 && object.borderRadius !== null ? Number(object.borderRadius) : void 0;
    message.type = object.type !== void 0 && object.type !== null ? appEmbedData_CardStyles_TypeFromJSON(object.type) : AppEmbedData_CardStyles_Type.CONTAINED;
    message.alignment = object.alignment !== void 0 && object.alignment !== null ? appEmbedData_CardStyles_AlignmentFromJSON(object.alignment) : AppEmbedData_CardStyles_Alignment.START;
    message.titlePriceLayout = object.titlePriceLayout !== void 0 && object.titlePriceLayout !== null ? appEmbedData_CardStyles_LayoutFromJSON(object.titlePriceLayout) : AppEmbedData_CardStyles_Layout.STACKED;
    message.titleColor = object.titleColor !== void 0 && object.titleColor !== null ? String(object.titleColor) : void 0;
    message.textColor = object.textColor !== void 0 && object.textColor !== null ? String(object.textColor) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.backgroundColor !== void 0 && (obj.backgroundColor = message.backgroundColor);
    message.borderColor !== void 0 && (obj.borderColor = message.borderColor);
    message.borderWidth !== void 0 && (obj.borderWidth = message.borderWidth);
    message.borderRadius !== void 0 && (obj.borderRadius = message.borderRadius);
    message.type !== void 0 && (obj.type = appEmbedData_CardStyles_TypeToJSON(message.type));
    message.alignment !== void 0 && (obj.alignment = appEmbedData_CardStyles_AlignmentToJSON(message.alignment));
    message.titlePriceLayout !== void 0 && (obj.titlePriceLayout = appEmbedData_CardStyles_LayoutToJSON(message.titlePriceLayout));
    message.titleColor !== void 0 && (obj.titleColor = message.titleColor);
    message.textColor !== void 0 && (obj.textColor = message.textColor);
    return obj;
  }
};
const baseAppEmbedData_BookingData = {};
const AppEmbedData_BookingData = {
  fromJSON(object) {
    const message = { ...baseAppEmbedData_BookingData };
    message.durations = object.durations !== void 0 && object.durations !== null ? String(object.durations) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.durations !== void 0 && (obj.durations = message.durations);
    return obj;
  }
};
const baseAppEmbedData_EventData = {};
const AppEmbedData_EventData = {
  fromJSON(object) {
    const message = { ...baseAppEmbedData_EventData };
    message.scheduling = object.scheduling !== void 0 && object.scheduling !== null ? String(object.scheduling) : void 0;
    message.location = object.location !== void 0 && object.location !== null ? String(object.location) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.scheduling !== void 0 && (obj.scheduling = message.scheduling);
    message.location !== void 0 && (obj.location = message.location);
    return obj;
  }
};
const baseAppEmbedData_PricingData = {};
const AppEmbedData_PricingData = {
  fromJSON(object) {
    const message = { ...baseAppEmbedData_PricingData };
    message.valueFrom = object.valueFrom !== void 0 && object.valueFrom !== null ? String(object.valueFrom) : void 0;
    message.valueTo = object.valueTo !== void 0 && object.valueTo !== null ? String(object.valueTo) : void 0;
    message.discountedValue = object.discountedValue !== void 0 && object.discountedValue !== null ? String(object.discountedValue) : void 0;
    message.currency = object.currency !== void 0 && object.currency !== null ? String(object.currency) : void 0;
    message.pricingPlanId = object.pricingPlanId !== void 0 && object.pricingPlanId !== null ? String(object.pricingPlanId) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.valueFrom !== void 0 && (obj.valueFrom = message.valueFrom);
    message.valueTo !== void 0 && (obj.valueTo = message.valueTo);
    message.discountedValue !== void 0 && (obj.discountedValue = message.discountedValue);
    message.currency !== void 0 && (obj.currency = message.currency);
    message.pricingPlanId !== void 0 && (obj.pricingPlanId = message.pricingPlanId);
    return obj;
  }
};
export {
  AppEmbedData,
  AppEmbedData_BookingData,
  AppEmbedData_ButtonStyles,
  AppEmbedData_CardStyles,
  AppEmbedData_EventData,
  AppEmbedData_ImageStyles,
  AppEmbedData_PricingData,
  AppEmbedData_RibbonStyles,
  appEmbedData_AppTypeFromJSON,
  appEmbedData_AppTypeToJSON,
  appEmbedData_CardStyles_AlignmentFromJSON,
  appEmbedData_CardStyles_AlignmentToJSON,
  appEmbedData_CardStyles_LayoutFromJSON,
  appEmbedData_CardStyles_LayoutToJSON,
  appEmbedData_CardStyles_TypeFromJSON,
  appEmbedData_CardStyles_TypeToJSON,
  appEmbedData_ImageStyles_AspectRatioFromJSON,
  appEmbedData_ImageStyles_AspectRatioToJSON,
  appEmbedData_ImageStyles_PositionFromJSON,
  appEmbedData_ImageStyles_PositionToJSON,
  appEmbedData_ImageStyles_ResizingFromJSON,
  appEmbedData_ImageStyles_ResizingToJSON,
  appEmbedData_RibbonStyles_PlacementFromJSON,
  appEmbedData_RibbonStyles_PlacementToJSON
};
//# sourceMappingURL=plugin_app_embed.js.map
